/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2018-09-25 22:19:50
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-10-11 18:57:39
 */

import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class TransService {
  lang: string;
  trans: any;

  constructor(private translate: TranslateService) {
    this.reload("en");
  }

  reload(lang) {
    this.lang = lang;

    this.translate
      .get([
        "BUTTON_DONE",
        "FORGOTPASSWORD_CONTENT",
        "MENU_CHOICE PATTERN",
        "MENU_TAKE A SHOT",
        "MENU_ALBUM",
        "MENU_EDIT",
        "POPUPTITLE_DELETE IT",
        "BUTTON_CANCEL",
        "BUTTON_DELETE",
        "BUTTON_OK",
        "BUTTON_OK2",
        "BUTTON_SAVE",
        "MENU_DELETE",
        "MENU_SPAM OR SCAM",
        "ARE YOU SURE YOU WANT TO CANCEL?",
        "ARE YOU SURE YOU WANT TO TODO?",
        "ARE YOU SURE YOU WANT TO SEND?",
        "SUCCESSFULLY COMPLETED.",
        "PLEASE ENTER YOUR PASSWORD CORRECTLY",
        "PLEASE ENTER YOUR NEW PASSWORD CORRECTLY",
        "WILL YOU STILL CONTINUE?",
        "YOUR CHANGES MAY NOT BE SAVED.",
        "BE SPECIFIC!",
        "SAVE VIDEO",
        "WOULD YOU LIKE TO SAVE THE VIDEO TO YOUR ALBUM?",
        "PLEASE SELECT YOUR DATE OF BIRTH.",
        "PLEASE SELECT YOUR COUNTRY.",
        "IT WILL BE AVAILABLE SOON.",
        "LABEL_RECIPIENT",
        "LABEL_REQUEST MESSAGE",
        "LABEL_BIO",
        "LABEL_EMAIL",
        "LABEL_PASSWORD",
        "LABEL_NEW PASSWORD",
        "LABEL_PASSWORD AGAIN",
        "LABEL_DONATION",
        "LABEL_PROCESSING",
        "LABEL_DONE",
        "LABEL_GENDER",
        "LABEL_BIRTH",
        "LABEL_COUNTRY",
        "LABEL_NAME",
        "LABEL_PHONE",
        "LABEL_CONTACT_DESCRIPTION",
        "LABEL_TODAY VIDEO",
        "LABEL_MY CELEB",
        "LABEL_NEW STAR",
        "LABEL_FOR YOU",
        "LABEL_ALL",
        "LABEL_FEMALE",
        "LABEL_MALE",
        "MENU_ALL",
        "MENU_Today video",
        "MENU_My Celeb",
        "MENU_Newbie Star",
        "TITLE_ACCOUNT PRIVACY",
        "TITLE_TERMS OF SERVICE",
        "TITLE_CATEGORY"
      ])
      .take(1)
      .subscribe(trans => {
        this.trans = trans;
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/trans.service.ts